import { createContext, FC, useContext, useEffect, useReducer, useState } from 'react';
import { InboxMessage, useInbox } from 'all-in-one-shared-api';
import { reducer } from './reducer';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { InboxMessageActionTypes } from './actions';
import { useKeycloakReady } from 'hooks';
import generateKey from '../../utils/generateKey';
import { useLocation } from 'react-router-dom';

interface InboxMessagesContextProps {
  inboxMessages: InboxMessage[];
  unreadMessageCount: number;
  fetchInboxMessages: () => void;
}

const initialState: InboxMessagesContextProps = {
  inboxMessages: [],
  unreadMessageCount: 0,
  fetchInboxMessages: () => null,
};

const InboxMessagesContext = createContext<InboxMessagesContextProps>(initialState);

export const useInboxMessagesContext = () => useContext(InboxMessagesContext);

const InboxMessagesContextProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { keycloak } = useKeycloak();
  const { tokenParsed } = useKeycloakReady();
  const [key, setKey] = useState<string>('');
  const { shouldFetch, mutate } = useInbox(
    // { name: 'useInbox', token: keycloak?.token, randoms },
    'useInbox' + key,
    keycloak?.token ?? '',
    {
      onSuccess: (data: InboxMessage[]) => {
        const sortDesc = (first: InboxMessage, second: InboxMessage) =>
          new Date(second.createDate ?? 0).getTime() - new Date(first.createDate ?? 0).getTime();
        const unreadMessageCount = (data ?? [])?.filter(({ shownDate }) => !shownDate)?.length ?? 0;
        dispatch({
          type: InboxMessageActionTypes.GET_MESSAGES,
          payload: {
            inboxMessages: data.sort(sortDesc) ?? [],
            unreadMessageCount,
          },
        });
      },
      refreshInterval: 1000 * 60,
    },
  );
  const location = useLocation();
  // Initial api endpoint call if authenticated
  useEffect(() => {
    if (tokenParsed?.ebClientKey) {
      setKey(generateKey());
      shouldFetch(!!keycloak.token);
    }
  }, [keycloak.token, shouldFetch, tokenParsed, location]);

  return (
    <InboxMessagesContext.Provider value={{ ...state, fetchInboxMessages: mutate }}>
      {children}
    </InboxMessagesContext.Provider>
  );
};

export default InboxMessagesContextProvider;
